import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './AppContext';
import Nav from './components/Nav';
import Login from './pages/Login';
import Home from './pages/Home';
import SignIns from './pages/SignIns';
import SignInLog from './pages/SignInLog';
import ManagerReport from './pages/ManagerReport';
import Members from './pages/Members';
import Parties from './pages/Parties';
import GuestLog from './pages/GuestLog';
import AdminPanel from './pages/AdminPanel';
import Account from './pages/Account';
import Settings from './pages/Settings';
import MemberImport from './pages/MemberImport';
import TwoFASetup from './pages/TwoFASetup';
import Instructions from './pages/Instructions';
import { FlaskRedirect, NotFound } from './pages/Stub';
import { api } from './api';

function AppShell() {
  const { user, loading, refresh } = useApp();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg)' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 32, height: 32, border: '2px solid var(--border)', borderTopColor: 'var(--accent)', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
          <div style={{ color: 'var(--fg3)', fontSize: 13, fontFamily: 'var(--font)' }}>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) return <Login onLogin={refresh} />;

  async function handleLogout() {
    await api.post('/api/logout', {});
    await refresh();
  }

  return (
    <>
      <Nav onLogout={handleLogout} />
      <Routes>
        <Route path="/"                  element={<Home />} />
        <Route path="/signins"           element={<SignIns />} />
        <Route path="/signin-log"        element={<SignInLog />} />
        <Route path="/manager-report"    element={<ManagerReport />} />
        <Route path="/members"           element={<Members />} />
        <Route path="/party"             element={<Parties />} />
        <Route path="/guests"            element={<GuestLog />} />
        <Route path="/admin"             element={<AdminPanel />} />
        <Route path="/account"           element={<Account />} />
        <Route path="/settings"          element={<Settings />} />
        <Route path="/membership-import" element={<MemberImport />} />
        <Route path="/2fa/setup"         element={<TwoFASetup />} />
        <Route path="/instructions"      element={<Instructions />} />
        <Route path="/code-generator"    element={<FlaskRedirect to={api.flaskUrl('/code-generator')} />} />
        <Route path="/settings/roles"    element={<FlaskRedirect to={api.flaskUrl('/settings/roles')} />} />
        <Route path="*"                  element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AppProvider>
  );
}
